import { useEffect } from "react";
import { Params, useParams } from "react-router-dom";
import { setActiveOrganization } from "@/store/uiSlice";
import { useAppDispatch, useAppSelector } from ".";

const IMPRESIONES_AEM = "njTiw4ZSrCL5dWje47UL";
const BITELINK = "Jl53LJOG9Sr7v60ltwj5";
const LA_CAMPANA = "WuTqUgHq1PV5j9hx5z0o";

const organizationList: Record<string, string> = {
  ["www.impresionesaem.com"]: IMPRESIONES_AEM,
  ["impresionesaem.com"]: IMPRESIONES_AEM,
  ["localhost:5173"]: IMPRESIONES_AEM,
  ["192.168.0.6:5173"]: IMPRESIONES_AEM,
  ["bitelink.app"]: BITELINK,
  ["www.bitelink.app"]: BITELINK,
  ["192.168.0.16:5173"]: BITELINK,
  ["www.uorder.app"]: LA_CAMPANA,
  ["uorder.app"]: LA_CAMPANA,
  ["http://localhost:5173"]: LA_CAMPANA,
};

const useOrganizationId = () => {
  const dispatch = useAppDispatch();
  const { organizationId } = useParams<Params>();
  const activeOrganization = useAppSelector((store) => store.ui.activeOrganization);

  const host: string = document.location.host;
  const domainId = organizationList[host];

  useEffect(() => {
    if (!activeOrganization && domainId) {
      dispatch(setActiveOrganization(domainId));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeOrganization, domainId]);

  return organizationId ?? domainId;
};

export default useOrganizationId;
